import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class ValidaRecuperarPassCorreoService implements CanActivate {

  preLogin:any = JSON.parse(sessionStorage.getItem('preLogin'));

  constructor(private router: Router) { }

  canActivate() {
    if (this.preLogin.codTpoPortal == 'HABIENTE' && this.preLogin.estadoPortal != 'SUSPENDIDO') {
      return true;
    } else {
      this.router.navigate(['inicio']);
      return false;
    }
  }

}